module.exports = __webpack_public_path__ + "static/media/roll-dice-100.2f6f56b0.png";